<template>
    <div class="FooterEmpresas">
        <div v-if="isLoading" class="center-spinner">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <template v-else>
            <header v-if="empresas.length > 0">
                <input type="text" class="form-control rounded mb-3" v-model="buscar" placeholder="Buscar" :readonly="!isActive" @click="isActive = true"  />
            </header>
            <div :class="{ 'content': !esModal && filtro.length > 0, 'content-modal': esModal && filtro.length > 0 }">
                <div
                    :class="{ 'scroll-body': !esModal && filtro.length > 1, 'scroll-body-modal': esModal && filtro.length > 1 }">
                    <div v-for="(item, index) of filtro" :key="index" class="card cursor-pointer"
                        :class="{ 'selected-item': item.id === idEmpresaSeleccionada, 'mt-3': index !== 0 }"
                        @click="seleccionarEmpresa(item.id, index)">
                        <div class="card-body d-flex w-100 flex-sm-row flex-column">
                            <div class="me-2">
                                <img class="shadow-sm rounded-pill border"
                                    :src="item.logo ? item.logo : $store.state.imagenes.defecto.foto" alt=""
                                    width="100px" />
                            </div>
                            <p class="card-text">
                                <b>{{ item.razonSocial }}
                                    <i v-if="item.verificada" class="fas fa-check-circle text-primary fs-9 ms-0"></i>
                                </b><br />
                                <b>NIT: </b>{{ item.nit }}<br />
                                {{ item.ciudad }},
                                {{ item.departamento === 'Archipiélago de San Andrés, Providencia y Santa Catalina' ?
            item.departamento = 'San Andrés y Providencia' : item.departamento }}<br />
                                <b>{{ item.sede }}</b>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="filtro.length === 0" class="col-md-12 mt-1">
                    <p class="text-center">No se encontraron empresas</p>
                </div>
            </div>
            <footer class="footer">
                <div v-if="filtro.length > 0 && buscar != ''" class="col-md-12 mt-1">
                    <p class="text-left">Se han encontrado <b>{{ filtro.length }}</b> empresa(s)</p>
                </div>
                <div v-if="filtro.length > 0 && !buscar" class="col-md-12 mt-1">
                    <p class="text-left">Tienes <b>{{ filtro.length }}</b> empresa(s) registrada(s)</p>
                </div>
            </footer>
        </template>
    </div>
</template>

<script>
import { auth, db } from "@/firebase";
import { collection, query, where, onSnapshot, doc, getDocs, updateDoc } from "firebase/firestore";
import _ from 'lodash';
export default {
    name: "FooterEmpresas",

    props: {
        esModal: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            idUsuario: "",
            idEmpresaSeleccionada: "",
            buscar: "",
            empresas: [],
            isLoading: false,
            isActive: false
        }
    },

    computed: {
        filtro() {
            return this.empresas.filter(empresa => {
                return (
                    empresa.nit.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.sede.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.razonSocial.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.ciudad.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.departamento.toLowerCase().includes(this.buscar.toLowerCase())
                );
            });
        },
    },

    mounted(){
        document.getElementById('empresasOffcanvas').addEventListener('hidden.bs.offcanvas', event => {
            this.isActive = false;
        })
    },

    async created() {
        let usuario = auth.currentUser;
        if (usuario) {
            let usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
            if (usuarioDB) {
                this.idUsuario = usuarioDB.id;
                await this.obtenerEmpresas()
                await this.obtenerEmpresaSeleccionada();
            }
        }
    },

    methods: {
        async obtenerEmpresas() {
            /* OBTENER ULTIMAS ACTUALIZACIONES */
            this.isLoading = true;
            this.empresas = [];
            const q = query(
                collection(db, "empresas"),
                where("registro.idUsuario", "==", this.idUsuario),
                where("registro.estado", "in", ['Creado', 'Editado'])
            );
            let querySnapshot = await getDocs(q);
            this.empresas = await Promise.all(
                querySnapshot.docs.map(async (doc) => {
                    return {
                        id: doc.id,
                        logo: doc.data().logo,
                        nit: doc.data().nit.numero.toString() + "-" + doc.data().nit.digitoVerificacion.toString(),
                        sede: doc.data().nit.nombre,
                        razonSocial: doc.data().razonSocial,
                        consecutivo: doc.data().nit.consecutivo,
                        ciudad: doc.data().ubicacion.ciudad,
                        departamento: doc.data().ubicacion.departamento,
                        verificada: doc.data().verificada
                    }
                })
            );
            let set = new Set(this.empresas.map(JSON.stringify));
            this.empresas = _.orderBy(Array.from(set).map(JSON.parse), ['consecutivo', 'razonSocial'], ['asc', "asc"]);

            /* COPIAR CONSULTA PARA COMPARAR CAMBIOS */
            let copia = await Promise.all(
                querySnapshot.docs.map((doc) => {
                    return { ...doc.data() }
                })
            );
            this.isLoading = false;

            /* DETECTAR ULTIMOS CAMBIOS */
            let cambios = [];
            onSnapshot(q, (snapshot) => {
                snapshot.docChanges().forEach((change) => {
                    if (change.type === 'added' || change.type === 'modified') {
                        cambios.push(change.doc.data());
                    } else if (change.type === "removed") {
                        for (let index = 0; index < this.empresas.length; index++) {
                            if (change.doc.id == this.empresas[index].id) {
                                this.empresas.splice(index, 1);
                            }
                        }
                    }
                });
                if (!_.isMatch([copia], [cambios]) && _.isMatch([cambios], [copia])) {
                    this.obtenerEmpresas();
                }
            });
        },

        async obtenerEmpresaSeleccionada() {
            onSnapshot(doc(db, "usuarios", this.idUsuario), async (doc) => {
                if (doc.data().preferencias.idEmpresaSeleccionada) {
                    let obtenerEmpresa = await this.$store.state.obtenerEmpresa(doc.data().preferencias.idEmpresaSeleccionada)
                    if (obtenerEmpresa && obtenerEmpresa.registro.estado !== 'Eliminado') {
                        this.idEmpresaSeleccionada = doc.data().preferencias.idEmpresaSeleccionada;
                        let indice = this.empresas.findIndex((i) => i.id === this.idEmpresaSeleccionada);
                        this.cambiarPosicionEmpresa(indice);
                    }
                } else {
                    this.idEmpresaSeleccionada = "";
                }
            });
        },

        async seleccionarEmpresa(id, index) {
            if (id != this.idEmpresaSeleccionada) {
                await updateDoc(doc(db, "usuarios", this.idUsuario), {
                    "preferencias.idEmpresaSeleccionada": id,
                });
                this.cambiarPosicionEmpresa(index);
                this.$router.go(0)
            }
        },

        cambiarPosicionEmpresa(index) {
            if (index < 0 || index >= this.empresas.length) {
                console.error('Índice inválido');
            }
            const selectedElement = this.empresas[index];
            this.empresas.splice(index, 1);
            this.empresas.unshift(selectedElement);
        },
    }
}
</script>

<style scoped>
.card {
    background-color: #f3f3f3;
}

.text-primary {
    color: #2f2f2f !important;
}

.fs-9 {
    font-size: 9pt
}

.center-spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    overflow: hidden;
    left: 50%;
    top: 50%;
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.cursor-pointer {
    cursor: pointer;
}

.scroll-body {
    overflow-y: scroll;
    overflow-x: hidden;
    flex-grow: 1;
    padding-right: 10px;
}

.scroll-body-modal {
    overflow-y: scroll;
    overflow-x: hidden;
    flex-grow: 1;
    padding-right: 10px;
}

.selected-item {
    border: 2px solid #6127ff;
    background-color: rgba(97, 39, 255, 0.3);
}

.content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 300px;
}

.content-modal {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: calc(64vh - 80px);
}

.fas.fa-check-circle {
    margin-top: 0px;
}

.footer {
    position: sticky;
    bottom: 1;
    z-index: 1;
    margin-top: 10px;
}

@media screen and (max-width: 990px) { 
    .content {
        height: 235px;
    }
}

@media screen and (max-width: 600px) {
    .content-modal {
        height: calc(55vh - 80px);
    }

    .card img {
        display: grid;
        margin: 0 auto;
        width: 85px;
        margin-bottom: 15px;
    }

    .card-text,
    .card-text b {
        font-size: 10.7pt !important;
    }
}

[data-bs-theme="dark"] .card {
    background-color: #343434;
}

[data-bs-theme="dark"] .selected-item {
    border: 2px solid #6127ff;
    background-color: rgba(97, 39, 255, 0.3);
}

[data-bs-theme="dark"] .text-primary {
    color: #fff !important;
}
</style>